module.exports = __webpack_public_path__ + "img/solar.4f28afa0.svg";